<template>
  <div class="page flex-col">
    <!-- Header Section -->
    <div class="banner-container flex-col">
      <div class="banner-content flex-row">
        <div class="text-group flex-col">
          <span class="banner-title">产业出海</span>
          <span class="banner-desc">全球视野，跨境合作<br>搭建国际产业合作桥梁，<br>助力企业拓展全球市场，实现国际化发展</span>
        </div>
      </div>
      <div class="consult-btn-wrapper flex-row" @click="jumpTo">
        <div class="consult-btn flex-col">立即咨询</div>
      </div>
    </div>

    <!-- Service List Section -->
    <div class="service-intro-container flex-col">
      <div class="intro-header">
        <span class="intro-main-title">基于IDICC全量产业数据底座，为意向出海企业提供以下服务：</span>
        <span class="intro-spacer"><br></span>
        <span class="highlight-title">智问：</span>
        <span class="highlight-desc">要不要出海？去哪国？去哪园？怎么去？怎么落地？<br></span>
        <span class="highlight-title">智策：</span>
        <span class="highlight-desc">出海可行性分析、选址论证分析<br></span>
        <span class="highlight-title">智服：</span>
        <span class="highlight-desc">围绕出海落地事项提供全流程服务</span>
      </div>

      <ServiceItem v-for="value in tabList" :key="value.name" :service-data="value" />
    </div>

    <!-- International Operation Center Section -->
    <div class="center-section flex-col">
      <div class="section-text-group flex-col">
        <span class="section-title">国际运营中心</span>
        <span class="section-subtitle">搭建国际产业合作桥梁，助力企业全球化发展</span>
      </div>

      <div class="center-list flex-row justify-between">
        <OperationCenter v-for="(center, index) in operationCenters" :key="index" :center="center" />
      </div>
    </div>

    <!-- Global Strategy Section -->
    <div class="strategy-section flex-col">
      <img class="strategy-image" referrerpolicy="no-referrer" src="https://static.idicc.cn/cdn/official/H5/dadaSea01.png" />
      <div class="strategy-text-group flex-col">
        <span class="strategy-title">全球市场拓展战略</span>
        <span class="strategy-desc">计划覆盖全球主要经济体和新兴市场</span>
      </div>
    </div>

    <!-- Country/Region List Section -->
    <div class="country-section flex-col">
      <div class="country-row flex-row justify-between" v-for="(row, rowIndex) in countryRows" :key="rowIndex">
        <div class="country-tag flex-col" v-for="(country, cIndex) in row" :key="cIndex"
          :class="{ 'opacitys': rowIndex > 0 }">
          <span class="country-name">{{ country }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
import ServiceItem from './components/ServiceItem.vue'
import OperationCenter from './components/OperationCenter.vue'

const router = useRouter()

const tabList = [
  {
    name: '出海AI秘书',
    value: '出海智问',
    serviceList: ['国家概况', '经商环境', '地理文化', '产业园区', '外资政策', 'OID备案'],
    backBg: 'https://static.idicc.cn/cdn/official/H5/dadaSea02.png',
    imgSize: ['300px', '354px'],
  },
  {
    name: '出海决策智脑',
    value: '出海智策',
    serviceList: ['出海策略报告', '海外选址论证报告', '市场匹配度', '风险预警', '应对机制'],
    backBg: 'https://static.idicc.cn/cdn/official/H5/dadaSea07.png',
    imgSize: ['200px', '250px'],
  },
  {
    name: '出海服务生态',
    value: '出海智服',
    serviceList: ['企业注册', '人力资源', '知识产权', '法律咨询', '产品认证', '语言服务'],
    backBg: 'https://static.idicc.cn/cdn/official/H5/dadaSea06.png',
    imgSize: ['180px', '255px'],
  },
]

const operationCenters = [
  {
    name: '泰国',
    fullName: '泰国运营中心',
  },
  {
    name: '马来',
    fullName: '马来西亚运营中心',
  },
  {
    name: '越南',
    fullName: '越南运营中心',
  },
]

const countryRows = [
  ['东南亚', '拉美', '中东中亚'],
  ['越南', '马来', '印尼'],
  ['墨西哥', '澳大利亚', '加拿大'],
  ['沙特', '阿联酋', '哈萨克斯坦'],
  ['巴西', '智利', '阿根廷'],
]

const jumpTo = () => {
  router.push({
    path: '/consultUsForm/report',
  })
}
</script>

<style lang="less" scoped>
.page {
  background-color: #ffffff;
  position: relative;
  width: 750px;

  .banner-container {
    background: center / contain no-repeat url(https://static.idicc.cn/cdn/official/H5/dadaSea04.png);
    padding: 100px 28px 33px 32px;
    background-size: 100% 101%;
    width: 100%;
    height: 420px;
    justify-content: center;
    align-items: center;

    .banner-content {
      .banner-title {
        overflow-wrap: break-word;
        color: #333333;
        font-size: 36px;
        font-family: AlimamaShuHeiTi-Bold;
        font-weight: 700;
        text-align: center;
        white-space: nowrap;
        line-height: 44px;
        align-self: center;
      }

      .banner-desc {
        width: 506px;
        overflow-wrap: break-word;
        color: #333333;
        font-size: 24px;
        font-family: AlibabaPuHuiTi_2_65_Medium;
        font-weight: normal;
        text-align: center;
        line-height: 33px;
        margin-top: 32px;
      }
    }

    .consult-btn-wrapper {
      margin-top: 32px;

      .consult-btn {
        width: 160px;
        height: 50px;
        background: center/contain no-repeat url(https://static.idicc.cn/cdn/official/H5/home_btn_bg.png);
        background-size: 100% 100%;
        color: #ffffff;
        font-size: 26px;
        font-family: AlibabaPuHuiTi_2_55_Regular;
        font-weight: normal;
        text-align: center;
        white-space: nowrap;
        line-height: 50px;
      }
    }
  }

  .service-intro-container {
    padding: 32px 32px 38px 32px;

    .intro-header {
      width: 686px;
      overflow-wrap: break-word;
      font-size: 0;
      font-family: AlibabaPuHuiTi_2_85_Bold;
      font-weight: normal;
      text-align: left;
      line-height: 40px;

      .intro-main-title {
        color: #333333;
        font-size: 28px;
        font-family: AlibabaPuHuiTi_2_85_Bold;
        font-weight: normal;
        line-height: 40px;
      }

      .intro-spacer,
      .highlight-desc {
        color: #666666;
        font-size: 28px;
        font-family: AlibabaPuHuiTi_2_55_Regular;
        font-weight: normal;
        line-height: 40px;
      }

      .highlight-title {
        color: #1741cd;
        font-size: 28px;
        font-family: AlibabaPuHuiTi_2_55_Regular;
        font-weight: normal;
        line-height: 40px;
      }
    }
  }

  .center-section {
    background-image: url(https://static.idicc.cn/cdn/official/H5/dadaSea03.png);
    margin-top: -1px;
    padding: 64px 15px 97px 15px;

    .section-text-group {
      width: 473px;
      align-self: center;

      .section-title {
        color: #ffffff;
        font-size: 36px;
        font-family: AlibabaPuHuiTi_2_85_Bold;
        font-weight: normal;
        text-align: center;
        white-space: nowrap;
        line-height: 50px;
        align-self: center;
      }

      .section-subtitle {
        color: #ffffff;
        font-size: 24px;
        font-family: AlibabaPuHuiTi_2_65_Medium;
        font-weight: normal;
        text-align: center;
        white-space: nowrap;
        line-height: 33px;
        margin-top: 16px;
      }
    }

    .center-list {
      width: 720px;
      margin-top: 40px;
    }
  }

  .strategy-section {
    padding: 50px 32px 21px 32px;

    .strategy-image {
      width: 686px;
      height: 357px;
    }

    .strategy-text-group {
      width: 441px;
      align-self: center;
      margin-top: 64px;

      .strategy-title {
        color: #333333;
        font-size: 36px;
        font-family: AlibabaPuHuiTi_2_85_Bold;
        font-weight: normal;
        text-align: center;
        white-space: nowrap;
        line-height: 50px;
        align-self: center;
      }

      .strategy-desc {
        color: #666666;
        font-size: 28px;
        font-family: AlibabaPuHuiTi_2_65_Medium;
        font-weight: normal;
        text-align: center;
        white-space: nowrap;
        line-height: 40px;
        margin-top: 16px;
      }
    }
  }

  .country-section {
    background-color: #e0e6f6;
    align-self: center;
    margin-bottom: 40px;
    width: 686px;
    padding: 29px 20px 32px 20px;

    .country-row {
      width: 646px;
      margin-top: 16px;

      &:first-child {
        margin-top: 0;
      }

      .country-tag {
        background-color: #ffffff;
        border-radius: 16px;
        border: 1px solid #e1e1e1;
        padding: 10px 0 16px 0;
        min-width: 140px;
        flex: 1;
        margin: 0 10px;

        &:first-child {
          margin-left: 0;
        }

        &:last-child {
          margin-right: 0;
        }

        &.opacitys {
          background-color: rgba(255, 255, 255, 0.4);
          border: 1px solid rgba(225, 225, 225, 0.4);

          .country-name {
            font-weight: normal;
          }
        }

        .country-name {
          color: #333333;
          font-size: 28px;
          font-family: AlibabaPuHuiTi_2_85_Bold;
          font-weight: 500;
          text-align: center;
          white-space: nowrap;
          line-height: 40px;
        }
      }
    }
  }
}

.flex-col {
  display: flex;
  flex-direction: column;
}

.flex-row {
  display: flex;
  flex-direction: row;
}

.justify-center {
  justify-content: center;
}

.align-center {
  align-items: center;
}

.justify-between {
  justify-content: space-between;
}
</style>
